import React from 'react';
//var parse = require( 'twitter-url-parser' );
import $ from 'jquery';
import {doRequest} from '../../../helper';

export default class TwitterPost extends React.Component {
    constructor( props ) {
        super( props );
        if ( props ) {
            this.state = props;
        } else {
            this.state = {};
        }
        this.id = "tweet_" + Math.random();
        this.saveSocial = this.saveSocial.bind( this );
    }
    componentDidMount() {

        var tweetId = "" + this.props.tweetId.N;
        //        if ( tweetId.indexOf( "http" ) != -1 ) {
        //            var result = parse( tweetId );
        //            tweetId = result.id;
        //        }

        var tweet = this.holder;
        var id = tweetId;

        window.twttr.widgets.createTweet(
            id, tweet,
            {
                omitScript: true
            } ).then(( res ) => {
                console.log( res );

            } ).catch( function( error ) {
                console.log( error );
            } );



    }

    saveSocial( twitterId ) {
        alert( twitterId );
        //save the social media post here
        var ref = this;
        var payload = {
            'action': 'save-post',
            'module': 'FitIndia',
            'model': 'post',
            'data': {
                'social_post_type': "twitter",
                'social_post_link': twitterId
            }
        };


        // $( ".loader" ).show();
        $( ".loader" ).show();

        var request = doRequest( 'cms-operations', payload, true );
        request.addEventListener( "load", function() {

            $( ".loader" ).hide();
            var response = this.responseText;
            try {
                response = JSON.parse( response );
                if ( response._resultflag && response._resultflag == 1 ) {
                    alert( 'Twitter Post Added' );
                }
            } catch ( ex ) {
                alert( 'Post can not be saved, please try again !' )
            }

        } );

    }

    render() {
        return ( <div className="ui-list-lp">
            <div ref={( holder ) => { this.holder = holder }} id={this.id} className="user-upl-stage">
                <a onClick={()=>{this.saveSocial( "" + this.props.tweetId.N )}} href="javascript:void(0);" className="btn btn-info add_to_feed" style={{
                    "position": "absolute",
                    "bottom": "10px",
                    "right": "30px"
                }}>Add to app feed</a>
            </div>
        </div> )
    }
}


// WEBPACK FOOTER //
// ./src/Components/FitIndia/Feeds/TwitterPost.jsx